import React, { Component } from 'react';
import Validator from 'validatorjs';

import Loading from '../../../../facturotopia/loading/Loading';
// import EmisorNominaInfoForm from '../components/EmisorNominaInfoForm';
import NominaOtrosPagosManager from './nomina/NominaOtrosPagosManager';
import NominaDeduccionesManager from './nomina/NominaDeduccionesManager';
// import ReceptorNominaInfoForm from '../components/ReceptorNominaInfoForm';
import NominaPercepcionesManager from './nomina/NominaPercepcionesManager';
import NominaIncapacidadesManager from './nomina/NominaIncapacidadesManager';
import NominaCatalogoManager from '../../../catalogs/managers/NominaCatalogoManager';
import ComplementoNominaGeneralInfo from './nomina/ComplementoNominaGeneralInfo';
import NominaTotalesCalculator from '../../support/nomina/NominaTotalesCalculator';

const steps = {
  general: false,
  percepciones: false,
  deducciones: false,
};

class ComplementoNomina extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      steps: { ...steps },
    };
  }

  getRules = (data) => {
    let additional = {};

    const { Percepciones } = data;
    const { Deducciones } = data;

    const hasPercepciones = !!Percepciones && !!Percepciones.Percepcion && Percepciones.Percepcion.length > 0;
    const hasDeducciones = !!Deducciones && !!Deducciones.Deduccion && Deducciones.Deduccion.length > 0;

    if (!hasPercepciones && !hasDeducciones) {
      additional = {
        'Deducciones.Deduccion': ['required', 'array', 'min:1'],
        'Percepciones.Percepcion': ['required', 'array', 'min:1'],
      };
    }

    if (this.isOtrosPagosRequired()) {
      additional['OtrosPagos.OtroPago'] = ['required', 'array', 'min:1'];
    }

    if (this.isIncapacidadesRequired()) {
      additional['Incapacidades.Incapacidad'] = ['required', 'array', 'min:1'];
    }

    return {
      TipoNomina: ['required', 'string', 'in:O,E'],
      FechaPago: [
        'required',
        // 'regex:/^[0-9]{2}/[0-9]{2}/[0-9]{4}$/'
      ],
      FechaInicialPago: [
        'required',
        // 'regex:/^[0-9]{2}/[0-9]{2}/[0-9]{4}$/'
      ],
      FechaFinalPago: [
        'required',
        // 'regex:/^[0-9]{2}/[0-9]{2}/[0-9]{4}$/'
      ],
      NumDiasPagados: [
        'required',
        'decimal:3',
        'min:0.001',
        'max:36160.000',
        'regex:/^(([1-9][0-9]{0,4})|[0])(.[0-9]{3})?$/',
      ],
      TotalPercepciones: ['decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      TotalDeducciones: ['decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      TotalOtrosPagos: ['decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],

      ...additional,
    };
  };

  async componentDidMount() {
    try {
      this.updateSteps();

      this.tryToUpdateEmisorAndReceptor();

      await NominaCatalogoManager.boot();

      let catalogos = {};

      catalogos.tipoNomina = [
        {
          label: 'Selecciona',
          value: '',
        },
      ].concat(
        NominaCatalogoManager.get('c_nom_tipo_nomina').map((item) => {
          return {
            label: item.descripcion,
            value: item.tipo,
          };
        })
      );

      this.setState({
        catalogos,
      });
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        message: error.message || 'Error recuperando catálogo de nómina',
      });
    }
  }

  componentDidUpdate() {
    // this.tryToUpdateEmisorAndReceptor();
  }

  updateSteps() {
    let steps = {
      general: !!this.props.data.TipoNomina || false,
      percepciones: !!this.props.data.Percepciones || false,
      deducciones: !!this.props.data.Deducciones || false,
    };

    this.setState({
      steps,
    });

    if (steps.general || steps.percepciones) {
      this.handleOnChange({});
    }
  }

  tryToUpdateEmisorAndReceptor() {
    const { data } = this.props;

    if (
      !!data.Emisor &&
      !!data.Emisor.id &&
      (!this.props.data.Emisor || data.Emisor.id !== this.props.data.Emisor.id)
    ) {
      const { nomina = {} } = data.Emisor;

      this.setState({
        ...this.state,
        data: {
          ...this.props.data,
          Emisor: {
            id: data.Emisor.id,
            ...nomina,
          },
        },
      });
    }

    if (
      !!data.Receptor &&
      !!data.Receptor.id &&
      !this.props.data.Receptor &&
      (!this.props.data.Receptor || data.Receptor.id !== this.props.data.Receptor.id)
    ) {
      const { nomina = {} } = data.Receptor;

      this.setState({
        ...this.state,
        data: {
          ...this.props.data,
          Receptor: {
            id: data.Receptor.id,
            ...nomina,
          },
        },
      });
    }
  }

  validate = (data) => {
    const validator = new Validator(data, this.getRules(data));

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  };

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value,
    };

    const validator = this.validate(data);

    this.props.onChange({
      data,
      isValid: validator.passes(),
    });
  };

  handleOnEmisorChange = (event) => {
    const data = {
      ...this.props.data,
      Emisor: {
        ...this.props.data.Emisor,
        ...event.data,
      },
    };

    this.handleOnChange(data);
  };

  handleOnReceptorChange = (event) => {
    const data = {
      ...this.props.data,
      Receptor: {
        ...this.props.data.Receptor,
        ...event.data,
      },
    };

    this.handleOnChange(data);
  };

  handleOnGeneralInfoChange = (event) => {
    this.handleOnChange(event.data);

    this.setState({
      ...this.state,
      steps: {
        ...this.state.steps,
        general: this.state.steps.general || event.isValid,
      },
    });
  };

  handleUnboundedNodeChanges = (value, step) => {
    let newData = {
      ...this.props.data,
      ...value,
    };

    const calc = NominaTotalesCalculator.make(newData).get();

    newData = {
      ...newData,
      TotalPercepciones: calc.totalPercepciones,
      TotalDeducciones: calc.totalDeducciones,
      TotalOtrosPagos: calc.totalOtrosPagos,
    };

    this.handleOnChange(newData);

    this.setState({
      ...this.state,
      steps: {
        ...this.state.steps,
        [step]: true,
      },
    });
  };

  handleOnPercepcionesChange = (value) => {
    this.handleUnboundedNodeChanges(value, 'percepciones');
  };

  handleOnDeduccionesChange = (value) => {
    this.handleUnboundedNodeChanges(value, 'deducciones');
  };

  handleOnOtrosPagosChange = (value) => {
    this.handleUnboundedNodeChanges(value, 'otros_pagos');
  };

  isIncapacidadesRequired = () => {
    const { Percepciones = {} } = this.props.data;
    const { Percepcion = [] } = Percepciones;

    let haystack = [
      '014', // “Subsidios por Incapacidad”
    ];

    for (const item of Percepcion) {
      if (haystack.indexOf(item.TipoPercepcion) !== -1) {
        return true;
      }
    }

    const { Deducciones = {} } = this.props.data;
    const { Deduccion = [] } = Deducciones;

    haystack = [
      '006', // “Descuento por incapacidad”
    ];

    for (const item of Deduccion) {
      if (haystack.indexOf(item.TipoDeduccion) !== -1) {
        return true;
      }
    }

    return false;
  };

  isOtrosPagosRequired = () => {
    const { Receptor = {} } = this.props.input;

    return Receptor.nomina?.TipoRegimen === '02';
  };

  handleOnAdd = () => {
    this.props.onChange({
      Nomina: { ...this.props.data },
    });
  };

  render() {
    const { steps, catalogos } = this.state;
    const { data = {} } = this.props;

    if (!catalogos) {
      return <Loading />;
    }

    return (
      <>
        {/* <div className="pb-4">
          <div>
            <strong className="text-black text-upper">Emisor</strong>
          </div>
          <div className="section pt-2">
            <EmisorNominaInfoForm
              data={data.Emisor || {}}
              onChange={this.handleOnEmisorChange}
            />
          </div>
        </div>

        <div className="pb-4">
          <div>
            <strong className="text-black text-upper">Receptor</strong>
          </div>
          <div className="section pt-2">
            <ReceptorNominaInfoForm
              data={data.Receptor || {}}
              onChange={this.handleOnReceptorChange}
            />
          </div>
        </div> */}

        <div className="pb-4">
          <strong className="text-black text-upper">Datos de Nómina</strong>
        </div>

        <ComplementoNominaGeneralInfo
          data={data}
          onChange={this.handleOnGeneralInfoChange}
        />

        <div className="pb-4">
          <strong className="text-black text-upper">Percepciones</strong>
        </div>

        {!!steps.general && (
          <NominaPercepcionesManager
            data={data}
            onChange={this.handleOnPercepcionesChange}
          />
        )}

        <div className="pb-4">
          <div>
            <strong className="text-black text-upper">Deducciones</strong>
          </div>
        </div>

        {!!steps.general && !!steps.percepciones && (
          <NominaDeduccionesManager
            data={data}
            onChange={this.handleOnDeduccionesChange}
          />
        )}

        {!!steps.general && !!steps.percepciones && !!this.isIncapacidadesRequired() && (
          <NominaIncapacidadesManager
            data={data}
            onChange={this.handleOnChange}
          />
        )}

        {!!steps.general && !!steps.percepciones && !!this.isOtrosPagosRequired() && (
          <NominaOtrosPagosManager
            data={data}
            onChange={this.handleOnOtrosPagosChange}
          />
        )}
      </>
    );
  }
}

export default ComplementoNomina;
